<script setup>
import GoodIcon from "@/components/Icons/GoodIcon.vue";
import SadIcon from "@/components/Icons/SadIcon.vue";
import NeutralIcon from "@/components/Icons/NeutralIcon.vue";
import {t} from "@/controllerLK/AvalLocalization";
import PencilIcon from "@/components/Icons/PencilIcon.vue";
import {useNewsFeedStore} from "@/store/NewsFeed/newsFeed";
import {useLK} from "@/controllerLK/LKstore";
import {markRaw, ref} from "vue";
import {AvalSentiment} from "@aval/ui-kit";

const newsFeedStore = useNewsFeedStore();
const LKStore = useLK();

// Флаг. Отображение окна изменения сантимента.
const isShowSentimentList = ref(false);

// Функция переключения видимости отображения окна сантимента
const toggleSentimentList = () => isShowSentimentList.value = !isShowSentimentList.value;

// Функция изменения сантимента
const changeSentiment = (item) => {
  newsFeedStore.currentNews.sentiment = item.value;
  newsFeedStore.changeSentiment(newsFeedStore.currentNews.id, item.value);
  newsFeedStore.updateFacet();
  isShowSentimentList.value = false;
};

// Список сантиментов
const sentimentList = [
  {
    component: markRaw(AvalSentiment),
    type: "neutral",
    value: 0,

  },
  {
    component: markRaw(AvalSentiment),
    type: "good",
    value: 1,
  },
  {
    component: markRaw(AvalSentiment),
    type: "sad",
    value: -1,
  },
];
</script>

<template>
  <div class="sentiment-switcher">
    <ul
      v-if="isShowSentimentList"
      v-click-outside="toggleSentimentList"
      class="sentiment-switcher__list"
    >
      <li
        v-for="item in sentimentList"
        :key="item"
        class="sentiment-switcher__list-item"
        :class="{'sentiment-switcher__list-item--active': newsFeedStore.currentNews.sentiment === item.value}"
        @click="changeSentiment(item)"
      >
        <Component
          :is="item.component"
          :type="item.type"
          :news="false"
          :model-value="newsFeedStore.currentNews.sentiment === item.value"
        />
      </li>
    </ul>

    <AvalButtonRoundedGhost
      size="extra-small"
      :class="{'sentiment-switcher__button--active': LKStore.user.roleNames.includes('аналитик')}"
      class="sentiment-switcher__button"
      @click="toggleSentimentList"
    >
      {{ t('news_page_body_post.label.sentiment') }}
      <PencilIcon v-if="LKStore.user.roleNames.includes('аналитик')" />
    </AvalButtonRoundedGhost>

    <Component
      :is="newsFeedStore.currentNews.sentiment > 0 ?
        GoodIcon : newsFeedStore.currentNews.sentiment < 0 ? SadIcon : NeutralIcon"
      v-if="newsFeedStore.currentNews.sentiment !== null"
      :news="true"
      class="sentiment-switcher__icon"
    />
    <span
      v-else
      class="sentiment-switcher__list--not-defined"
    >
      {{ t('news_page_body_post.label.not_defined') }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.sentiment-switcher {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;

  &__list {
    display: flex;
    padding: 6px;
    gap: 6px;
    border-radius: 8px;
    box-shadow: 2px 4px 20px 0 #00203926;
    background-color: var(--background-bg-white);
    position: absolute;
    top: calc(100%);
    left: 0;
    z-index: 9999;

    &--not-defined {
      color: rgba(123, 135, 165, 0.3);
    }

  }

  &__icon {
    width: 20px;
    height: 20px;
  }

  &__button--active {
    pointer-events: auto !important;
  }

  &__button.button-rounded-ghost {
    padding: 3px 0 3px 0;
    pointer-events: none;
    height: 24px;
  }
}
</style>